import Swiper from "swiper";
import { Pagination, A11y } from "swiper/modules";

// Configure Swiper to use modules
Swiper.use([Pagination, A11y]);

const swiper = new Swiper(".swiper", {
  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    1048: {
      slidesPerView: 2,
      spaceBetween: 70,
      slidesPerGroup: 2,
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// animação

const sectionAnimation = () => {
  const sections = document.querySelectorAll("[data-animate]");

  sections.forEach((section) => {
    const halfWindow = window.innerHeight * 0.6;
    const isSectionVisible =
      section.getBoundingClientRect().top - halfWindow < 0;

    if (isSectionVisible) {
      section.setAttribute("data-animate", "true");
    }
  });
};

window.addEventListener("scroll", sectionAnimation);
